import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/UsersList.module.css";
import { IoIosSearch } from "react-icons/io";
import { RxDotsHorizontal } from "react-icons/rx";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  InputAdornment,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
  Typography,
  useTheme,
  IconButton,
} from "@mui/material";
import { RxCross1 } from "react-icons/rx";
import AddUserModal from "../components/AddEditUserModal";
import editLogo from "../assets/EditIcon.svg";
import disableLogo from "../assets/disable.svg";
import addIcon from "../assets/AddIcon.svg";
import { useQuery, useMutation } from "react-query";
import axios from "../utilis/axios";
import moment from "moment";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "../store";
import { Skeleton } from "@mui/material";
import PaginationComponent from "components/ui-components/PaginationComponent";
import filterUp from "assets/FilterUp.svg";
import filterDown from "assets/FilterDown.svg";
import BulkUploadModal from "components/BulkUpload";
import { useParams } from "react-router-dom";
import ClearIcon from "@mui/icons-material/ClearOutlined";
import { usePermission } from "hooks/usePermission";
import { USERS_ADD, USERS_BULK_UPLOAD, USERS_EDIT, USERS_DISABLE } from "config";
import { useGetAllRoleQuery } from "store/slices/apis/rolePackageSlice";
import UserDisabledAction from "./UserDisabledAction";
import { useGetDesignationListQuery, useGetUsersListQuery } from "store/slices/apis/userAccountSlice";
import { ReactComponent as AddNewIcon } from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"
import { ReactComponent as SearchIcon } from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as ChevronDown } from "assets/PwC_Funct_Icons_ChevronDown_Outline_Black_RGB.svg"
import { ReactComponent as ChevronUp } from "assets/PwC_Funct_Icons_ChevronUp_Outline_Black_RGB.svg"
import { ReactComponent as FilterIcon } from "assets/PwC_Funct_Icons_Filter_Outline_Black_RGB.svg"
import { ReactComponent as MorewHorizontalIcon } from "assets/PwC_Funct_Icons_MoreHorizontal_Outline_Black_RGB.svg"
import { ReactComponent as EditIcon } from "assets/PwC_Funct_Icons_Edit_Outline_Black_RGB.svg"
import { ReactComponent as RejectIcon } from "assets/PwC_Funct_Icons_CircleMinus_Outline_Black_RGB.svg"

// const fetchUsers = async ({ queryKey }) => {
//   const [
//     ,
//     { pageNumber, pageSize, searchQuery, selectedDesignations, projectId },
//   ] = queryKey;

//   try {
//     let url = `account/List?pageNumber=${pageNumber}&pageSize=${pageSize}`;
//     if (searchQuery) {
//       url += `&searchQuery=${encodeURIComponent(searchQuery?.trim())}`;
//     }
//     if (projectId) {
//       url += `&projectId=${encodeURIComponent(projectId)}`;
//     }
//     if (selectedDesignations.length > 0) {
//       url += `&designations=${encodeURIComponent(
//         selectedDesignations.join(",")
//       )}`;
//     }

//     const response = await axios.get(url);
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Something went wrong");
//   }
// };

// const fetchRoles = async () => {
//   try {
//     const response = await axios.get("Roles");
//     return response.data.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Something went wrong");
//   }
// };

// const fetchDesignations = async () => {
//   try {
//     const response = await axios.get("account/DesignationList");
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Something went wrong");
//   }
// };

const updateUser = async (userData) => {
  try {
    const response = await axios.put("account/update", userData);
    return response.data;
  } catch (error) {
    throw new Error(error.value || "Something went wrong");
  }
};

const UsersList = () => {
  const inputRef = useRef();
  const rolesRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openRoleDropdown, setOpenRoleDropdown] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [openOptions, setOpenOptions] = useState(false);
  const [disabledAction, setDisabledAction] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [clickedUserId, setClickedUserId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  // useOutsideClick(inputRef, () => setOpenOptions(null));
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDesignations, setSelectedDesignations] = useState([]);
  const [tempSelectedDesignations, setTempSelectedDesignations] = useState([]);
  const [showDesignations, setShowDesignations] = useState(true);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const { projectId } = useParams();
  const canDisableUser = usePermission(USERS_DISABLE);
  const canEditUser = usePermission(USERS_EDIT);

  // console.log(canDisableUser, canEditUser);


  useEffect(() => {
    setPageNumber(1);
  }, [searchQuery, selectedDesignations]);

  // const { data, status, refetch } = useQuery(
  //   [
  //     "getUsersList",
  //     { pageNumber, pageSize, searchQuery, selectedDesignations, projectId },
  //   ],
  //   fetchUsers,
  //   {
  //     keepPreviousData: true,
  //     enabled: searchQuery.length >= 3 || searchQuery.length === 0,
  //   }
  // );
  //  const { data: usersRecords,isLoading:status,refetch } = useGetUsersListQuery(
  const { data: rolesData, isLoading } = useGetAllRoleQuery(
    projectId != undefined && (
      { projectId: projectId }
    )
  );

  const { data: usersRecords, isLoading: status, refetch } = useGetUsersListQuery(
    {
      pageSize,
      pageNumber,
      ...(searchQuery?.trim()?.length >= 3 ? { searchQuery: encodeURIComponent(searchQuery?.trim()) } : {}),
      ...(selectedDesignations.length > 0 ? { designations: encodeURIComponent(selectedDesignations.join(",")) } : {}),
      ...(projectId != undefined ? { projectId: projectId } : {}),
    },
    {
      skip: searchQuery?.length > 0 && searchQuery?.length < 3,
    }
  );
  const { data: designationData } = useGetDesignationListQuery(
    projectId != undefined && (
      { projectId: projectId }
    )
  );

  // const { data: designationData, status: designationStatus } = useQuery(
  //   "getDesignations",
  //   fetchDesignations
  // );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTempSelectedDesignations(selectedDesignations);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (designation) => {
    const updatedSelections = tempSelectedDesignations.includes(designation)
      ? tempSelectedDesignations.filter((item) => item !== designation)
      : [...tempSelectedDesignations, designation];
    setTempSelectedDesignations(updatedSelections);
  };

  const handleApply = () => {
    setSelectedDesignations(tempSelectedDesignations);
    handleClose();
  };

  const handleCancel = () => {
    setTempSelectedDesignations(selectedDesignations);
    handleClose();
  };

  const toggleDesignations = () => {
    setShowDesignations(!showDesignations);
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  const filteredUsers = usersRecords?.users?.filter((user) => {
    const query = searchQuery.trim().toLowerCase();
    const fullName = `${(user?.firstName?.trim() || "").toLowerCase()} ${(
      user?.lastName?.trim() || ""
    ).toLowerCase()}`;
    const userName = (user?.userName?.trim() || "").toLowerCase();
    const designation = (user?.designation?.trim() || "").toLowerCase();
    const phoneNumber = (user?.phoneNumber?.trim() || "").toLowerCase();
    const email = (user?.email?.trim() || "").toLowerCase();

    const matchesSearchQuery =
      fullName.includes(query) ||
      user?.firstName?.trim().toLowerCase().includes(query) ||
      user?.lastName?.trim().toLowerCase().includes(query) ||
      userName.includes(query) ||
      designation.includes(query) ||
      phoneNumber.includes(query) ||
      email.includes(query);

    const matchesDesignation =
      selectedDesignations.length === 0 ||
      selectedDesignations.includes(user?.designation?.trim());

    return matchesSearchQuery && matchesDesignation;
  });

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: { color: type },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 10000);
  };

  const updateUserMutation = useMutation(updateUser, {
    onSuccess: (response) => {
      openNotification(response?.msg || "User updated successfully", "success");
    },
    onError: (error) => {
      openNotification(error?.message || "Something went wrong");
    },
  });

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleOptions = (userId, e) => {
    e.stopPropagation();
    if (clickedUserId === userId) {
      setOpenOptions(!openOptions);
    } else {
      setClickedUserId(userId);
      setOpenOptions(true);
    }
  };

  const handleOpenModal = (user = null) => {
    setSelectedUser(user);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedUser(null);
  };

  const toggleRoleDropdown = (userId, e) => {
    e.stopPropagation();
    if (currentUserId === userId) {
      setOpenRoleDropdown(!openRoleDropdown);
    } else {
      setCurrentUserId(userId);
      setOpenRoleDropdown(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (rolesRef.current && !rolesRef.current.contains(e.target)) {
        setOpenRoleDropdown(false);
      }
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setOpenOptions(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getRoleDisplayNames = (roleNames) => {
    if (!rolesData?.data || !roleNames) return [];

    const allRoles = [];

    for (let i = 0; i < roleNames.length; i++) {
      const roleName = roleNames[i];

      const foundRole = rolesData?.data.find((role) => role.name === roleName);
      let tempRoles = null;
      if (foundRole) {
        tempRoles = { id: foundRole.name, name: foundRole.displayName };
      }
      if (tempRoles !== null) {
        allRoles.push(tempRoles);
      }
    }
    return allRoles;
  };

  const handleRoleChange = async (user, roleId, e) => {
    e.stopPropagation();
    const updatedRoles = selectedRoles.includes(roleId)
      ? selectedRoles.filter((r) => r !== roleId)
      : [...selectedRoles, roleId];

    setSelectedRoles(updatedRoles);

    const updatedUser = {
      Id: user.id,
      UserName: user.firstName,
      Email: user.email,
      FirstName: user.firstName,
      LastName: user.lastName,
      Designation: user.designation,
      PhoneNumber: user.phoneNumber,
      RoleName: updatedRoles,
    };

    try {
      await updateUserMutation.mutateAsync(updatedUser);
      // refetch();
    } catch (error) { }
  };

  const handleRemoveRole = async (user, roleId) => {
    const updatedRoles = user.roleName.filter((role) => role !== roleId);
    const updatedUser = {
      Id: user.id,
      UserName: user.firstName,
      Email: user.email,
      FirstName: user.firstName,
      LastName: user.lastName,
      Designation: user.designation,
      PhoneNumber: user.phoneNumber,
      RoleName: updatedRoles,
    };

    try {
      await updateUserMutation.mutateAsync(updatedUser);
      // refetch();
    } catch (error) {
      console.error("Error", error);
    }
  };

  const handleSaveUser = () => {
    refetch();
    handleCloseModal();
  };

  const handleAction = (row) => {
    setDisabledAction((prev) => {
      const newState = !prev;
      setRowData(newState ? row : null);
      return newState;
    });
  }

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.info}>
          <div className={styles.infoTag}>User List</div>
          <div className={styles.infoUsers}>
            {usersRecords?.users?.length} {usersRecords?.users?.length <= 1 ? "user" : "users"}{" "}
            / {usersRecords?.totalCount} {usersRecords?.totalCount <= 1 ? "user" : "users"}
          </div>
        </div>
        {usePermission(USERS_ADD) &&
          <Button
            sx={{
              backgroundColor: theme?.customSettings?.themeColor,
              color: "#FFF",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "24px",
              padding: "8px 24px 8px 16px",
              textTransform: "none",
              borderRadius: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              whiteSpace: "nowrap",
            }}
            onClick={handleOpenModal}
          >
            <AddNewIcon style={{ height: 20, width: 20, fill: "#FFF" }} />
            Add users
          </Button>
        }
        <AddUserModal
          open={openModal}
          handleClose={handleCloseModal}
          user={selectedUser}
          onSubmit={handleSaveUser}
        />
      </div>
      <div className={styles.list}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: { xs: 'column', sm: 'row' },
            gap: "20px",
          }}
        >
          <TextField
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <IoIosSearch className={styles.searchIcon} /> */}
                  <SearchIcon style={{ height: "20px", width: "20px", fill: "#808080" }} />
                </InputAdornment>
              ),
              style: {
                fontSize: "16px",
              },
              endAdornment: searchQuery?.length > 0 && (
                <IconButton onClick={clearSearch} edge="end">
                  {/* <ClearIcon style={{ fontSize: "16px" }} /> */}
                  <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px", fill: "#808080" }} />
                </IconButton>
              ),
            }}
            sx={{
              width: { xs: "100%", sm: '32%' },
              height: "48px",
              maxWidth: "500px",
              background: "#fff",
              "& .MuiInputBase-root": {
                height: "48px",
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: "400",
                color: "#696969",
                opacity: 1,
              },
              "& .MuiInputBase-input::placeholder": {
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: "400",
                color: "#696969",
                opacity: 1,
              },
            }}
          />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <Button
              onClick={handleClick}
              className={styles.filterBtn}
              sx={{
                backgroundColor: `${theme?.customSettings?.themeColor}1F`,
                color: "#FFF",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div className={styles.filterImg}>
                {/* <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg" */}

                <FilterIcon
                  style={{
                    width: "30px",
                    height: "30px",
                    fill: theme?.customSettings?.themeColor,
                  }}
                //    >
                //   <path d="M0 0V4L5.008 6.992L6 16H10L10.496 11.504L11.008 6.992L16 4V0H0ZM1.008 0.992H15.008V3.504H1.008V0.992ZM5.936 6.4L2.784 4.496H13.216L10.064 6.4L9.6 10.496H6.4L5.936 6.4ZM6.512 11.504H9.488L9.104 15.008H6.896L6.512 11.504Z" />
                // </svg>
                />
              </div>
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500",
                  color: theme?.customSettings?.themeColor,
                }}
              >
                Filters
              </Typography>

              <div className={styles.filterImg}>
                {/* <svg
                  width="16"
                  height="10"
                  viewBox="0 0 16 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg */}

                <ChevronDown
                  style={{
                    width: "30px",
                    height: "30px",
                    fill: theme?.customSettings?.themeColor,
                  }}
                //                     >
                //   <path d="M0.848 9.20805L8 2.05605L15.152 9.20805C15.248 9.30405 15.3653 9.35205 15.504 9.35205C15.6427 9.35205 15.76 9.30405 15.856 9.20805C15.952 9.11205 16 8.99472 16 8.85605C16 8.71738 15.952 8.60005 15.856 8.50405L8 0.64805L0.143999 8.50405C0.0480003 8.60005 0 8.71738 0 8.85605C0 8.99472 0.0480003 9.11205 0.143999 9.20805C0.24 9.30405 0.357332 9.35205 0.495999 9.35205C0.634666 9.35205 0.751999 9.30405 0.848 9.20805Z" />
                // </svg>


                />
              </div>
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              PaperProps={{
                style: {
                  width: 230,
                  marginTop: "10px",
                },
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "white",
                  zIndex: 2,
                  padding: "8px 20px 8px 12px",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "#252525",
                  "&:hover": {
                    backgroundColor: "#e8e8e8 !important",
                  },
                }}
                onClick={toggleDesignations}
              >
                Designations
                {/* <img
                  src={showDesignations ? filterUp : filterDown}
                  alt="arrow"
                  style={{ width: "16px", height: "16px" }}
                /> */}
                {showDesignations ? (
                  <ChevronUp style={{ width: "20px", height: "20px" }} />
                ) : (
                  <ChevronDown style={{ width: "20px", height: "20px" }} />
                )}
              </Box>
              {showDesignations && (
                <Box
                  sx={{
                    maxHeight: 176,
                    overflowY: "auto",
                  }}
                >
                  {designationData?.map((item) => (
                    <MenuItem
                      key={item?.designation}
                      sx={{
                        padding: "4px 16px !important",
                        "& .MuiFormControlLabel-root": {
                          minWidth: "205px !important",
                        },
                        "&:hover": {
                          backgroundColor: "#e8e8e8 !important",
                        },
                      }}
                    >
                      <FormControlLabel
                        sx={{
                          width: "100%",
                          "& .MuiFormControlLabel-label": {
                            flex: 1,
                          },
                        }}
                        control={
                          <Checkbox
                            checked={tempSelectedDesignations.includes(
                              item?.designation
                            )}
                            onChange={() =>
                              handleCheckboxChange(item?.designation)
                            }
                            color="primary"
                            sx={{
                              padding: "5px",
                              "& .css-1umw9bq-MuiSvgIcon-root": {
                                fill: theme?.customSettings?.themeColor,
                              },
                            }}
                          />
                        }
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                              gap: "8px",
                            }}
                          >
                            <span className={styles.filterItems}>
                              {item?.designation}
                            </span>
                            <span className={styles.filterItems}>
                              {item?.count}
                            </span>
                          </Box>
                        }
                        labelPlacement="end"
                      />
                    </MenuItem>
                  ))}
                </Box>
              )}
              <Box
                display="flex"
                gap="8px"
                padding="12px"
                position="sticky"
                bottom={0}
                backgroundColor="white"
                zIndex={1}
              >
                <Button
                  onClick={handleCancel}
                  sx={{
                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    textTransform: "capitalize",
                    flex: 1,
                    color: theme?.customSettings?.themeColor,
                    textTransform: "none",
                  }}
                >
                  Close
                </Button>
                <Button
                  onClick={handleApply}
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "20px",
                    textTransform: "capitalize",
                    backgroundColor: theme?.customSettings?.themeColor,
                    color: "#FFF !important",
                    flex: 1,
                    textTransform: "none",
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Menu>
            {usePermission(USERS_BULK_UPLOAD) &&
              <Button
                sx={{
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  color: theme?.customSettings?.themeColor,
                  fontSize: "16px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  padding: "8px 48px 8px 40px",
                  flex: 1,
                  textTransform: "capitalize",
                  whiteSpace: "nowrap",
                }}
                onClick={() => setBulkUploadModal(!bulkUploadModal)}
              >
                Bulk Upload
              </Button>
            }
            <BulkUploadModal
              bulkUploadModal={bulkUploadModal}
              setBulkUploadModal={setBulkUploadModal}
            />
          </Box>
        </Box>

        <Box>
          <TableContainer component={Paper} className={styles.table}>
            <Table>
              <TableHead className={styles.table_head}>
                <TableRow className={styles.table_row}>
                  <TableCell
                    className={`${styles.table_header} ${styles.table_header_admin}`}
                  >
                    Admin
                  </TableCell>
                  <TableCell
                    className={`${styles.table_header} ${styles.table_header_role}`}
                  >
                    Role
                  </TableCell>
                  <TableCell
                    className={`${styles.table_header} ${styles.table_header_login}`}
                  >
                    Last Login
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {status === "loading" ? (
                  [...Array(5)].map((_, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Skeleton variant="text" width={150} height={30} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={100} height={30} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="text" width={120} height={30} />
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="circular" width={24} height={24} />
                      </TableCell>
                    </TableRow>
                  ))
                ) : filteredUsers && filteredUsers.length > 0 ? (
                  filteredUsers.map((user, index) => {
                    const userRoles = getRoleDisplayNames(user.roleName);
                    return (
                      <TableRow
                        key={user.id}
                        sx={{
                          "& .css-1dc80h3-MuiTableCell-root": {
                            padding: "12px",
                          },
                          "& .css-1t595qo-MuiTableCell-root": {
                            padding: "12px",
                          },
                        }}
                      >
                        <TableCell style={{ borderBottom: "none" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              className={styles.userInitials}
                              style={{
                                background: theme?.customSettings?.themeColor,
                                color: "#ffff",
                              }}
                            >
                              {(user.firstName
                                ?.split(" ")
                                .map((n) => n[0])
                                .join("") || "N.A.") +
                                (user.lastName
                                  ?.split(" ")
                                  .map((n) => n[0])
                                  .join("") || "N.A.")}
                            </div>
                            <div>
                              <div className={styles.name}>
                                {user.firstName || "N.A."}{" "}
                                {user.lastName || "N.A."}
                              </div>
                              <div className={styles.email}>
                                {user.email || "N.A."}
                              </div>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell sx={{ borderBottom: "none" }} key={user?.id}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              whiteSpace: "nowrap",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div
                              className={styles.addIcon}
                              onClick={(e) => toggleRoleDropdown(user?.id, e)}
                            >
                              {/* <div className={styles.addLogo}>
                                <img src={addIcon} alt="AddIcon" />
                              </div> */}
                              {openRoleDropdown &&
                                currentUserId === user?.id &&
                                rolesData?.data && (
                                  <div
                                    className={styles.rolesCard}
                                    ref={rolesRef}
                                  >
                                    {rolesData?.data.map((role) => {
                                      const isChecked =
                                        selectedRoles.includes(role.id) ||
                                        user?.roleName.includes(role.name);
                                      const totalChecked =
                                        selectedRoles.length ||
                                        user?.roleName.length;
                                      return (
                                        <div
                                          key={role?.id}
                                          className={styles.roleItem}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={isChecked}
                                            className={styles.checkbox}
                                            disabled={
                                              isChecked && totalChecked === 1
                                            }
                                            onChange={(e) =>
                                              handleRoleChange(
                                                user,
                                                role?.name,
                                                e
                                              )
                                            }
                                            style={{
                                              cursor:
                                                userRoles.length > 1
                                                  ? "pointer"
                                                  : "not-allowed",
                                              opacity:
                                                userRoles.length > 1 ? 1 : 0.5,
                                              backgroundColor:
                                                theme?.customSettings
                                                  ?.themeColor,
                                              borderColor:
                                                theme?.customSettings
                                                  ?.themeColor,
                                            }}
                                          />
                                          <label>{role?.displayName}</label>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                            </div>
                            {user?.rolesName?.map((role,ind) => (
                              <div key={ind} className={styles.roles}>
                                <span
                                  className={styles.role}
                                  style={{
                                    background:
                                      theme?.customSettings?.themeColor,
                                    color: "#ffff",
                                  }}
                                >
                                  {role}
                                  {/* <RxCross1 */}
                                  {/* <CrossIcon
                                    onClick={() => {
                                      if (userRoles.length > 1) {
                                        handleRemoveRole(user, role.id);
                                      }
                                    }}
                                    style={{
                                      width: "14px",
                                      height: "14px",
                                      fill: "#fff",
                                      cursor:
                                        userRoles.length > 1
                                          ? "pointer"
                                          : "not-allowed",
                                      opacity: userRoles.length > 1 ? 1 : 0.5,
                                    }}
                                  /> */}
                                </span>
                              </div>
                            ))}
                            {/* {userRoles.map((role) => (
                              <div key={role?.id} className={styles.roles}>
                                <span
                                  className={styles.role}
                                  style={{
                                    background:
                                      theme?.customSettings?.themeColor,
                                    color: "#ffff",
                                  }}
                                >
                                  {role?.name}
                                  
                                  <CrossIcon
                                    onClick={() => {
                                      if (userRoles.length > 1) {
                                        handleRemoveRole(user, role.id);
                                      }
                                    }}
                                    style={{
                                      width: "14px",
                                      height: "14px",
                                      fill: "#fff",
                                      cursor:
                                        userRoles.length > 1
                                          ? "pointer"
                                          : "not-allowed",
                                      opacity: userRoles.length > 1 ? 1 : 0.5,
                                    }}
                                  />
                                </span>
                              </div>
                            ))} */}
                          </div>
                        </TableCell>
                        <TableCell
                          style={{ borderBottom: "none" }}
                          key={user?.id}
                        >
                          <div
                            className={styles.login}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <span className={styles.text}>
                              {user?.lastLogin !== null
                                ? moment(user?.lastLogin)
                                  .startOf("hour")
                                  .fromNow()
                                : "Invited"}
                              {/* <div className={styles.optionsLogo}>
                                <img src={refresh} alt="Refresh" />
                              </div> */}
                            </span>
                            {(canDisableUser || canEditUser) &&
                              <span
                                className={styles.options}
                                onClick={(e) => toggleOptions(user?.id, e)}
                              >
                                {/* <RxDotsHorizontal /> */}
                                <MorewHorizontalIcon style={{ fill: "#808080" }} />
                              </span>
                            }

                            {openOptions && clickedUserId === user?.id && (
                              <div
                                className={styles.optionsContainer}
                                ref={inputRef}
                              >
                                <div className={styles.createdAt}>
                                  Created:{" "}
                                  {moment(user?.createdDate).format(
                                    "DD/MM/YY"
                                  ) || "N.A."}
                                </div>
                                {canEditUser &&
                                  <button
                                    className={styles.optionButton}
                                    onClick={() => {
                                      handleOpenModal(user);
                                      setOpenOptions(false);
                                      setClickedUserId(null);
                                    }}
                                  >
                                    <div className={styles.optionsLogo}>
                                      {/* <img src={editLogo} alt="" /> */}
                                      <EditIcon style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    Edit user details
                                  </button>
                                }
                                {canDisableUser &&
                                  <button
                                    className={styles.optionButton}
                                    onClick={() => {
                                      handleAction(user)
                                      // setOpenOptions(false);
                                      // setClickedUserId(null);
                                    }}
                                  >
                                    <div className={styles.optionsLogo}>
                                      {/* <img src={disableLogo} alt="" /> */}
                                      <RejectIcon style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    Disable user account
                                  </button>
                                }


                                {/* <button
                                  className={styles.optionButton}
                                  onClick={() => {
                                    setOpenOptions(false);
                                    setClickedUserId(null);
                                  }}
                                >
                                  <div className={styles.optionsLogo}>
                                    <img src={deleteLogo} alt="" />
                                  </div>
                                  Delete user account
                                </button> */}
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={4}
                      align="center"
                      sx={{
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: 500,
                      }}
                    >
                      No users found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
            }}
          >
            {/* <Grid2 container>
              <Grid2 size={{ xs: 12, md: 12 }}>
                <Typography
                  variant="body2"
                  textAlign={"center"}
                  sx={{
                    fontSize: "13px",
                    color: "#252525",
                    opacity: 0.5,
                    textAlign: "left",
                    mt: 2,
                  }}
                >
                  &copy; 2025 PwC (RAD App Local). All rights reserved. PwC
                  refers to the US member firm of the PwC network or one of its
                  subsidiaries or affiliates. 3.0.x
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 2 }} />
              <Grid2 size={{ xs: 12, md: 12 }} textAlign={"left"}>
                <Link href="#" className={styles.footer_link}>
                  Contact Support
                </Link>{" "}
                <span style={{ color: "#252525", opacity: "0.5" }}>|</span>{" "}
                <Link href="#" className={styles.footer_link}>
                  Legal Disclaimer
                </Link>{" "}
                <span style={{ color: "#252525", opacity: "0.5" }}>|</span>{" "}
                <Link href="#" className={styles.footer_link}>
                  Click me!
                </Link>
              </Grid2>
            </Grid2> */}
            <PaginationComponent
              pageNumber={usersRecords?.pageNumber || 1}
              totalPages={usersRecords?.totalPages || 1}
              onPageChange={setPageNumber}
            />
          </Box>
        </Box>
      </div>
      {
        disabledAction &&
        <UserDisabledAction open={disabledAction} cancel={handleAction} rowData={rowData} />

      }
    </div >


  );
};

export default UsersList;
